// Slug utilities for treatment area (and future) URLs.
// Rule of thumb: lowercase, ASCII, kebab-case, no leading/trailing hyphens.

export const slugify = (raw) =>
  String(raw || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // strip accents
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Given a proposed slug and a list of taken slugs, return one that's unique
// by appending -2, -3, … if needed.
export const uniqueSlug = (base, taken = []) => {
  const b = slugify(base) || "item";
  const set = new Set(taken.filter(Boolean));
  if (!set.has(b)) return b;
  let n = 2;
  while (set.has(`${b}-${n}`)) n += 1;
  return `${b}-${n}`;
};
